/**
 * The disconnect dialog's message key — a pure decision, so it can be tested without the data layer.
 * Same rule as native's `connectorDisconnectBodyKey`.
 *
 * Removing one account of a multiply-linked row leaves the connector connected, so nothing happens to its
 * routines. A whole Composio disconnect deletes them. Every other row (MCP, calendar, Wix service) only has
 * them paused until a reconnect, because symphony-genome deletes routines on a Composio disconnect only.
 *
 * `alsoRemoves` is the row's `disconnectAlsoRemoves`: what the server says a whole disconnect removes beyond Symphony.
 * The server names the effect and never the connector, so no client picks copy by toolkit. An effect this build does
 * not know reads as absent.
 */
export type DisconnectConfirmKey =
  | 'connectors.disconnect.confirm'
  | 'connectors.disconnect.confirmWithRoutines'
  | 'connectors.disconnect.confirmPausesRoutines'
  | 'connectors.disconnect.confirmAlsoSocialMarketing';

export function disconnectConfirmKey(provider: string | undefined, removesConnector: boolean, alsoRemoves?: string): DisconnectConfirmKey {
  if (!removesConnector) {
    return 'connectors.disconnect.confirm';
  }
  if (alsoRemoves === 'wix-social-marketing') {
    return 'connectors.disconnect.confirmAlsoSocialMarketing';
  }
  // No provider is the Composio rail, as in `connectorConnectRoute`.
  const deletesRoutines = !provider || provider === 'composio';
  return deletesRoutines ? 'connectors.disconnect.confirmWithRoutines' : 'connectors.disconnect.confirmPausesRoutines';
}
